import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';

import { IStickyBlockProps } from './types';

import * as styles from './StickyBlock.css';

export const StickyBlock: FC<PropsWithChildren<IStickyBlockProps>> = props => {
  const { children, containerClassName } = props;

  return <div className={clsx(styles['container'], containerClassName)}>{children}</div>;
};

StickyBlock.displayName = 'StickyBlock';
